import api from "@/app/_module/services/api";
import { getApiUrl } from "@/app/_module/services/config";
import { endpoint } from "@/app/_module/services/endpoints";
import { handleApiCall } from "@/app/_module/utils/apiResponseHandler";

import type { UpdateNotificationPreferencesRequest, NotificationPreferences } from "../types/NotificationPreferences";

export const notificationPreferencesService = {
  getNotificationPreferences: async (): Promise<NotificationPreferences> => {
    const response = await handleApiCall(async () => await api.get({
      url: getApiUrl(endpoint.notifications.getPreferences),
      auth: true
    }));
    return response.effective || response;
  },

  updateNotificationPreferences: async (preferences: UpdateNotificationPreferencesRequest): Promise<NotificationPreferences> => {
    const response = await handleApiCall(async () => await api.patch({
      url: getApiUrl(endpoint.notifications.updatePreferences),
      body: preferences,
      auth: true
    }));
    return response.effective || response;
  },
};
